const features = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: '多平台聚合',
    desc: '红桃、樱桃、茄子、糖心四大平台资源一站聚合，告别多个APP反复切换的繁琐体验',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '多线路智能分流技术，4G/5G/WiFi环境下均能流畅播放，告别缓冲等待的烦恼',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全平台片源均采用高清编码，支持1080P乃至4K画质输出，给你影院级观影享受',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '实时更新',
    desc: '热门剧集上线24小时内即完成同步，追剧日历自动提醒，不错过任何精彩更新',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          为什么选择玫瑰视频
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          四大核心优势，打造极致追剧体验
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}